import React, { useRef, useState } from 'react';
import { Modal, Collapse, Carousel } from 'antd';
import { fakeProImage } from '../../config/fakeData';
import { ModalCarouselWrapper } from "./style";
import { AddCommas, primaryColor } from '../../config';
import { Link } from 'react-router-dom';

const AMAZON_BASE_URL = "https://www.amazon.in/dp/";

const SLIDE_LABELS = ['Performance', 'Cost', 'Profit'];

const OrderDetailsModal = ({ open, onClose, data, currencySign }) => {
    const mainCollapseRef = useRef(null);
    const carouselRef     = useRef(null);
    const [currentSlide, setCurrentSlide] = useState(0);

    // const getAmount = (val) => {
    //     const amount = parseFloat(val || 0);
    //     return `${amount < 0 ? '-' : ''}${currencySign}${Math.abs(amount).toFixed(2)}`;
    // };
    const getAmount = (val) => {
        const amount = parseFloat(val || 0);
        const formattedNumber = AddCommas(Math.abs(amount).toFixed(2));
        return `${amount < 0 ? '-' : ''}${currencySign}${formattedNumber}`;
    };

    const handleCollapseChange = (activeKeys) => {
        if (Array.isArray(activeKeys) && activeKeys.length > 0) {
            const newlyOpenedKey = activeKeys[activeKeys.length - 1];
            const panelHeader = mainCollapseRef.current?.querySelector(`.ant-collapse-item[data-key="${newlyOpenedKey}"] .ant-collapse-header`);
            if (panelHeader) panelHeader.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }
    };

    const generateOrderMetrics = (orderData) => {
        if (!orderData || !orderData.more_info) return { revenueMetrics: [], costMetrics: [], profitabilityMetrics: [] };

        const info = orderData.more_info;

        const revenueMetrics = [
            { key: '1', title: 'Sales', amount: getAmount(info.sales), items: [] },
            { key: '2', title: 'Units', amount: `${info.units || 0}`, items: [] },
            { key: '3', title: 'Promo', amount: getAmount(info.promo), items: [] },
            { key: '4', title: 'Gift Wrap', amount: getAmount(info.giftwrap), items: [] },
        ];

        const costMetrics = [
            {
                key: '1',
                title: 'Amazon Fees',
                amount: getAmount(info.amazon_fees?.total),
                items: [
                    { label: 'FBA Fulfilment', value: getAmount(info.amazon_fees?.fba_per_unit_fulfilment_fee) },
                    { label: 'FBA Weight Based Fee', value: getAmount(info.amazon_fees?.fba_weight_based_fee) },
                    { label: 'Fixed Closing Fee', value: getAmount(info.amazon_fees?.fixed_closing_fee) },
                    { label: 'Item TDS', value: getAmount(info.amazon_fees?.item_TDS) },
                ]
            },
            { key: '2', title: 'Shipping Cost', amount: getAmount(-info.shipping_cost), items: [] },
            { key: '3', title: 'Cost of Goods', amount: getAmount(-info.cost_of_goods), items: [] },
            { key: '4', title: 'VAT', amount: getAmount(info.vat), items: [] },
        ];

        const profitabilityMetrics = [
            { key: '1', title: 'Gross Profit', amount: getAmount(info.gross_profit), items: [] },
            { key: '2', title: 'Net Profit', amount: getAmount(info.net_profit), items: [] },
            { key: '3', title: 'Estimated Payout', amount: getAmount(info.estimated_payout), items: [] },
        ];

        const format = (items) => items.map(section => ({
            key: section.key,
            label: (
                <div className="d-flex justify-content-between w-100">
                    <span className="text-gray-800 fw-bold fs-6">{section.title}</span>
                    <span className="text-gray-800 fw-bolder fs-6 me-3">{section.amount}</span>
                </div>
            ),
            children: section.items?.length > 0 ? (
                <div className="ps-4">
                    {section.items.map((item, i) => (
                        <div key={i} className="d-flex justify-content-between py-1 border-bottom border-bottom-dashed">
                            <span className="text-gray-600">{item.label}</span>
                            <span className="fw-bold">{item.value}</span>
                        </div>
                    ))}
                </div>
            ) : null,
            showArrow: section.items?.length > 0,
            collapsible: section.items?.length > 0 ? '' : 'disabled'
        }));

        return {
            revenue: format(revenueMetrics),
            costs: format(costMetrics),
            profitability: format(profitabilityMetrics)
        };
    };

    const { revenue, costs, profitability } = generateOrderMetrics(data);

    return (
        <ModalCarouselWrapper>
            <Modal open={open} onCancel={onClose} footer={null} width={650} centered className="custom-modal">
                {data && (
                    <div style={{ padding: '20px' }}>
                        <div className="text-center mb-4">
                            <img src={data.image_url || fakeProImage} alt="Product" style={{ maxHeight: 120, objectFit: 'contain' }} />
                            <h3 className="mt-3 fs-5 px-5">
                                <Link
                                    to={data.asin ? `${AMAZON_BASE_URL}${data.asin}` : "#"}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{ lineHeight:1.6}}
                                    className='text-dark text-hover-danger'
                                >
                                    {data.product_name}
                                </Link>
                           
                            </h3>
                            <div className="text-muted fs-7">Order ID: <b className="text-dark">{data.order_id}</b></div>
                        </div>

                        {/* Tab navigation — synced with carousel */}
                        <div style={{ display: 'flex', gap: 6, width: '100%', paddingBottom: 2, marginBottom: 12 }}>
                            {SLIDE_LABELS.map((label, i) => {
                                const isActive = i === currentSlide;
                                return (
                                    <button
                                        key={label}
                                        onClick={() => carouselRef.current?.goTo(i)}
                                        aria-label={`Show ${label}`}
                                        title={label}
                                        style={{
                                            flex: 1,
                                            padding: '7px 8px',
                                            border: `1.5px solid ${isActive ? '#314F71' : '#e4e6ef'}`,
                                            borderRadius: 8,
                                            background: isActive ? '#314F71' : 'transparent',
                                            color: isActive ? '#ffffff' : '#7e8299',
                                            fontSize: 12.5,
                                            fontWeight: 600,
                                            cursor: 'pointer',
                                            outline: 'none',
                                            whiteSpace: 'nowrap',
                                            textAlign: 'center',
                                            boxShadow: isActive ? '0 3px 10px rgba(49,79,113,0.35)' : 'none',
                                            transition: 'background 0.2s ease, color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease',
                                        }}
                                    >
                                        {label}
                                    </button>
                                );
                            })}
                        </div>

                        <Carousel
                            ref={carouselRef}
                            dots={false}
                            afterChange={(index) => setCurrentSlide(index)}
                        >
                            <div>
                                <div className="modal-collapse-scrollable">
                                    <Collapse items={revenue} bordered={false} onChange={handleCollapseChange} ref={mainCollapseRef}/>
                                </div>
                            </div>
                            <div>
                                <div className="modal-collapse-scrollable">
                                    <Collapse items={costs} bordered={false} onChange={handleCollapseChange} ref={mainCollapseRef}/>
                                </div>
                            </div>
                            <div>
                                <div className="modal-collapse-scrollable">
                                    <Collapse items={profitability} bordered={false} onChange={handleCollapseChange} ref={mainCollapseRef}/>
                                </div>
                            </div>
                        </Carousel>

                        <div
                            className="mt-5 p-4 rounded border border-dashed d-flex justify-content-between align-items-center" style={{ backgroundColor: "#DAF3E4" }}>
                            <h4 className="mb-0 fw-bold" style={{ color: "#0F7E3E" }}>Net Profit</h4>
                            <h2 className="mb-0 fw-bolder" style={{ color: "#0F7E3E" }}>{getAmount(data.more_info?.net_profit)}</h2>
                        </div>
                    </div>
                )}
            </Modal>
        </ModalCarouselWrapper>
    );
};

export default OrderDetailsModal;

